<template>
  <ed-input-select
    :label="label"
    :name="name"
    :value="value"
    :info="info"
    :readonly="readonly"
    :disabled="disabled"
    :color="color"
    :items="[
      { id: 1, nome: 'SIM' },
      { id: 0, nome: 'NÃO' },
    ]"
    @input="$emit('input', $event)"
    chips
  />
</template>

<script>
import EdFormMixin from "./mixins/formControl";
import EdInputSelect from "./EdInputSelect";

export default {
  name: "EdInputSwitch",
  mixins: [EdFormMixin],
  components:{EdInputSelect},
  props: {},
  data() {
    return {
      model: [],
    };
  },
  beforeDestroy() {},
  created() {},
  mounted() {},
  computed: {},
  methods: {
  },
  watch: {},
};
</script>


// WEBPACK FOOTER //
// src/components/template/EdInputSwitch.vue